// Recherche dans le document : PDFFindController de pdf.js, boîte sous la loupe comme l'ancien visualiseur.
// Ctrl+F (Cmd+F sur Mac) ouvre cette recherche à la place de celle du navigateur.

// États de pdf.js (FindState)
const TROUVE = 0;
const INTROUVABLE = 1;
const BOUCLE = 2;
const EN_COURS = 3;

export function initialiserRecherche(section, { eventBus }) {
  const bouton    = section.querySelector('[data-action="recherche"]');
  const boite     = section.querySelector('.pdf-recherche');
  const champ     = boite.querySelector('.pdf-recherche-champ');
  const tout      = boite.querySelector('.pdf-recherche-tout');
  const casse     = boite.querySelector('.pdf-recherche-casse');
  const resultat  = boite.querySelector('.pdf-recherche-resultat');

  const chercher = (type, precedent = false) => {
    eventBus.dispatch('find', {
      source: boite,
      type,
      query: champ.value,
      caseSensitive: casse.checked,
      entireWord: false,
      highlightAll: tout.checked,
      findPrevious: precedent,
      matchDiacritics: false, // « ecole » trouve aussi « école »
    });
  };

  const ouvrir = () => {
    boite.hidden = false;
    bouton.setAttribute('aria-expanded', 'true');
    champ.focus();
    champ.select();
  };

  const fermer = () => {
    boite.hidden = true;
    bouton.setAttribute('aria-expanded', 'false');
    eventBus.dispatch('findbarclose', { source: boite });
  };

  bouton.hidden = false;
  bouton.addEventListener('click', () => (boite.hidden ? ouvrir() : fermer()));

  champ.addEventListener('input', () => chercher(''));
  champ.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      chercher('again', e.shiftKey);
    }
  });

  boite.querySelector('[data-action="occurrence-precedente"]').addEventListener('click', () => chercher('again', true));
  boite.querySelector('[data-action="occurrence-suivante"]').addEventListener('click', () => chercher('again'));
  tout.addEventListener('change', () => chercher('highlightallchange'));
  casse.addEventListener('change', () => chercher('casesensitivitychange'));

  document.addEventListener('keydown', (e) => {
    if ((e.ctrlKey || e.metaKey) && !e.altKey && e.key.toLowerCase() === 'f') {
      e.preventDefault();
      ouvrir();
    } else if (e.key === 'Escape' && !boite.hidden && boite.contains(document.activeElement)) {
      fermer();
      bouton.focus();
    }
  });

  // ── Résultats ──────────────────────────────────────────────────────────────

  const afficherNombre = ({ current, total }) => {
    if (!total) return '';
    return total === 1 ? '1 correspondance' : `${current} sur ${total} correspondances`;
  };

  eventBus.on('updatefindmatchescount', ({ matchesCount }) => {
    resultat.textContent = afficherNombre(matchesCount);
  });

  eventBus.on('updatefindcontrolstate', ({ state, previous, matchesCount }) => {
    champ.removeAttribute('data-statut');
    boite.removeAttribute('aria-busy');

    if (champ.value === '') {
      resultat.textContent = '';
      return;
    }

    switch (state) {
      case INTROUVABLE:
        champ.setAttribute('data-statut', 'introuvable');
        resultat.textContent = 'Phrase introuvable';
        break;
      case BOUCLE:
        resultat.textContent = previous
          ? 'Début du document atteint, poursuite à la fin'
          : 'Fin du document atteinte, poursuite au début';
        break;
      case EN_COURS:
        boite.setAttribute('aria-busy', 'true');
        break;
      case TROUVE:
        resultat.textContent = afficherNombre(matchesCount);
        break;
    }
  });
}
